import Vue from 'vue'
import Router from 'vue-router'
import MainVue from '@/components/MainVue'
import CityMain from '@/components/CityMain'
import AdminMain from '@/components/admin/Main'
import AdminUsers from '@/components/admin/Users'
import AdminCities from '@/components/admin/Cities'
import AdminCourses from '@/components/admin/GlobalCourses'
import AdminCourseEdit from '@/components/admin/GlobalCourseEdit'
import AdminActiveView from '@/components/admin/ActiveView'
import AdminSecurity from '@/components/admin/Security'
import UserPreferences from '@/components/UserPreferences'
import CityVehicles from '@/components/city/Vehicles'
import CityStaff from '@/components/city/Staff'
import CityLocations from '@/components/city/Locations'
import CityCourses from '@/components/city/Courses'
import CityCourseEdit from '@/components/city/CourseEdit'
import CityMainDefault from '@/components/city/Default'
import CityNewWeekend from '@/components/city/weekend/NewWeekend'
import CityWeekendEdit from '@/components/city/weekend/WeekendEdit'
import CityWeekendReports from '@/components/city/weekend/WeekendReports'
import CityWeekeends from '@/components/city/weekend/AllWeekends'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'MainVue',
      component: MainVue
    },
    {
      path: '/city/:abbreviation',
      component: CityMain,
      children: [
        {
          name: 'CityMain',
          path: '',
          component: CityMainDefault
        },
        {
          path: 'settings/vehicles',
          component: CityVehicles
        },
        {
          path: 'settings/staff',
          component: CityStaff
        },
        {
          path: 'settings/locations',
          component: CityLocations
        },
        {
          path: 'settings/courses',
          component: CityCourses
        },
        {
          path: 'settings/course/:courseId',
          component: CityCourseEdit
        },
        {
          path: 'new',
          component: CityNewWeekend
        },
        {
          path: 'weekend/:weekendId',
          component: CityWeekendEdit
        },
        {
          path: 'weekendReports/:weekendId',
          component: CityWeekendReports
        },
        {
          path: 'weekends',
          component: CityWeekeends
        }
      ]
    },
    {
      path: '/admin',
      name: 'admin-main',
      component: AdminMain,
      meta: {admin: true}
    },
    {
      path: '/admin/users',
      name: 'admin-users',
      component: AdminUsers,
      meta: {admin: true}
    },
    {
      path: '/admin/cities',
      name: 'admin-cities',
      component: AdminCities,
      meta: {admin: true}
    },
    {
      path: '/admin/activeview',
      name: 'admin-activeview',
      component: AdminActiveView,
      meta: {admin: true}
    },
    {
      path: '/admin/security',
      name: 'admin-security',
      component: AdminSecurity,
      meta: {admin: true}
    },
    {
      path: '/admin/courses',
      name: 'admin-courses',
      component: AdminCourses,
      meta: {admin: true}
    },
    {
      path: '/admin/course/:courseId',
      name: 'admin-courseedit',
      component: AdminCourseEdit,
      meta: {admin: true}
    },
    {
      path: '/preferences',
      name: 'user-preferences',
      component: UserPreferences
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js